<template>
  <div v-show="show">
    <header class="header-main" v-show="!$route.meta.hideHeader">
      <div class="containers">
        <router-link to="/" style="cursor:pointer" :class="customClass()">
          <img :src="getTranslations.logo_for_branded_projects || 'static/images/logo.svg'" alt=""></router-link>
        <nav :class="customClassForBurgerMenu()">
          <button data-menu="nav_dropdown_lang" class="nav__toggle nav__toggle_lang" v-if="!hideLangSelection && !customForWeTpay()"></button>
          <button data-menu="nav_dropdown_burgerMenu" :class="['nav__toggle nav__toggle_burgerMenu', isIos ? 'ui_desc_ios' : '']"><span></span></button>
          <button data-menu="nav_dropdown_lang" class="nav__toggle nav__toggle_lang" v-if="!hideLangSelection && customForWeTpay()"></button>
          <div id="nav_dropdown_burgerMenu" class="nav-dropdown nav_dropdown_burgerMenu">
            <ul>
              <li v-if="!hidePrizePage">
                <router-link to="/prizes" :class="getActiveTabClass('/prizes')" style="cursor:pointer">
                  {{ getTranslations.visitor_visitor_header_prizes }}
                </router-link>
              </li>
              <li v-if="!hideWinners">
                <router-link to="/winners" :class="getActiveTabClass('/winners')" style="cursor:pointer">
                  {{ getTranslations.visitor_visitor_header_winners }}
                </router-link>
              </li>
              <li>
                <router-link to="/howItWorks" :class="getActiveTabClass('/howItWorks')" style="cursor:pointer">
                  {{ getTranslations.visitor_visitor_header_how_it_works }}
                </router-link>
              </li>
            </ul>
          </div>
          <div id="nav_dropdown_lang" class="nav-dropdown nav_dropdown_lang">
            <ul>
              <li v-for="(value, key) in availableLocales" :key="key" style="cursor:pointer">
                <a @click.prevent="changeLanguage(key)" :class="getActiveTabLocale(key)">{{ value }} </a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <router-view></router-view>
    <!-- get_started_skin_footer.html if skin=1 EXC-3424 -->
    <footer :class="['footer-main ', customFooterOrNot()]" v-if="logoOnFooter">
      <h6 v-if="duelSkin !== 1">{{ getTranslations.visitor_visitor_brought_to_you }}
        <img class="operator_footer_logo" :src="[getTranslations.project_config_visitor_footer_logo]"></h6>

      <a v-if="duelSkin !== 1" class="footer_links"
         :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')"
         target="_blank">
        <h4> {{ getTranslations.visitor_visitor_privacy_policy }}</h4>
      </a>

      <a v-if="duelSkin !== 1" class="footer_links"
         :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
         target="_blank">
        <h4>{{ getTranslations.visitor_t_and_c }}</h4>
      </a>

      <div class="col-md-4 skin1_footer_left" v-if="duelSkin === 1">
        <a class="footer_links"
           :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_privacy_and_policy')"
           target="_blank">
          <h4> {{ getTranslations.visitor_visitor_privacy_policy }}</h4>
        </a>
      </div>
      <div class="col-md-4 skin1_footer_center" v-if="duelSkin === 1">
        <img class="operator_footer_logo" :src="operatorLogoForBrandedProject">
      </div>
      <div v-if="duelSkin === 1" class="col-md-4 skin1_footer_right">
        <a class="footer_links"
           :href="getTranslationByOperator(multiOperatorInfo.multiOperatorOrdinal, 'project_config_visitor_register_3_terms_and_conditions')"
           target="_blank">
          <h4>{{ getTranslations.visitor_t_and_c }}</h4>
        </a>
      </div>
    </footer>

    <simplify-registration v-if="showSimpleRegistrationModal"
                           @close="showSimpleRegistrationModal = false;">
    </simplify-registration>
    <sub-verify-wifi v-if="HE_ERROR_CODE"
                     @close="HE_ERROR_CODE = false;">
    </sub-verify-wifi>
    <operator-selection v-if="getSelectOperatorModalChoice()"
                        @close="toggleSelectOperatorModal(false);">
    </operator-selection>

    <div class="row random_waves">
      <div class="col-lg-2">
        <span class="waves wave3"></span>
      </div>
      <div class="col-lg-8"></div>
      <div class="col-lg-2">
        <span class="waves wave4"></span>
      </div>
    </div>

    <div class="black-overlay"></div>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import Vue from 'vue';
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import IntegrationMixin from '@/common/mixins/integration';
import RegistrationFlowMixin from '@/common/mixins/flow';
import simplifyRegistration from '@/components/home/modals/SimplifyRegistration';
import subVerifyWifi from '@/components/home/modals/SubscriptionVerifyWifi';
import operatorSelection from '@/components/home/modals/OperatorSelectionModal';
import { handleLang, handleLangMenuActiveChoice, handleBurger, handleBurgerMenuActiveChoice } from '../../common/jQuery';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'navigation-header',
  mixins: [IntegrationMixin, RegistrationFlowMixin],
  components: { simplifyRegistration, subVerifyWifi, operatorSelection },
  data() {
    return {
      isIos: false,
      operatorLogoForBrandedProject: '',
      currentTabPath: '',
      showSimpleRegistrationModal: false,
      show: true,
    };
  },
  // eslint-disable-next-line
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.hidePage()) vm.showPage(false);
      vm.getIntegration(to);
    });
  },
  created() {
    this.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this.currentTabPath = sessionStorage.getItem('visitorCurrentTabPath');
    this.operatorLogoForBrandedProject = this.isBrandedProject ? `static/skins/skin_${this.duelSkin.toString()}/images/logo-operator-footer.svg` : '';
  },
  mounted() {
    console.log(this.getDisplayedLocale);
    this.$nextTick(() => {
      handleBurgerMenuActiveChoice();
      handleLangMenuActiveChoice();
      handleBurger();
      handleLang();
    });
  },
  beforeRouteUpdate(to, from, next) {
    // eslint-disable-next-line
    $(window).scrollTop(0);
    this.getIntegration(to);
    this.currentTabPath = to.path;
    sessionStorage.setItem('visitorCurrentTabPath', to.path);
    next();
  },
  methods: {
    ...mapActions('common', [
      'facebookSDKApi',
    ]),
    ...mapActions('profile', [
      'storeVisitorWinners',
      'storeAvailablePrizeTypes',
      'storeAvailablePrizeTypesPerGame',
    ]),
    ...mapActions('i18n', [
      'getTranslationsFile',
    ]),
    ...mapMutations('i18n', [
      'setLocale',
      'changeCSSFile',
    ]),
    ...mapMutations('common', [
      'setUserLanguage',
    ]),
    customFooterOrNot() {
      if (this.duelSkin !== 1) {
        return '';
      }
      return 'skin1';
    },
    customClass() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && !this.multiOperatorInfo.multiOperatorEnabled) {
        return 'logo-header_custom';
      }
      return 'logo-header';
    },
    customClassForBurgerMenu() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && !this.multiOperatorInfo.multiOperatorEnabled) {
        return 'main-nav main-nav--home custom_header';
      }
      return 'main-nav main-nav--home';
    },
    customForWeTpay() {
      if (this.integrationHeader === this.availableIntegrations.TPAY_EGYPT.name && !this.multiOperatorInfo.multiOperatorEnabled) {
        return true;
      }
      return false;
    },
    showPage(value) {
      this.show = value;
    },
    getIntegration(to) {
      if (to.path === '/') this.checkForRegisterRedirect(to);
      else this.showPage(true);
    },
    checkForRegisterRedirect(to) {
      this.getIntegrationParametersCheck()(to);
    },
    toCreditsPage() {
      this.$router.push('/credits');
    },
    changeLanguage(newValue) {
      console.log(`New Language ${newValue}`);
      this.setUserLanguage(newValue);
      localStorage.setItem('locale', newValue);
      this.setLocale({ currentLocale: newValue });
      this.getTranslationsFile().then(() => {
        moment.locale(this.getLocale.toLowerCase());
        this.storeVisitorWinners(localStorage.getItem('locale')).then(() => {
          this.storeAvailablePrizeTypes(localStorage.getItem('locale')).then(() => {
            this.storeAvailablePrizeTypesPerGame(localStorage.getItem('locale'));
            this.facebookSDKApi().then(() => {
              this.changeCSSFile();
            });
          });
        });
      });
    },
    getActiveTabLocale(key) {
      return this.getLocale === key ? 'active' : '';
    },
    getActiveTabClass(path) {
      return this.currentTabPath === path ? 'active' : '';
    },

  },
  computed: {
    ...mapState('i18n', [
      'availableLocales',
    ]),
    ...mapState('common', [
      'hideLangSelection',
      'hidePrizePage',
      'hideWinners',
      'logoOnFooter',
      'multiOperatorInfo',
      'duelSkin',
      'isBrandedProject',
    ]),
    ...mapGetters('i18n', [
      'getLocale',
      'getDisplayedLocale',
      'getTranslationByOperator',
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/visitor/Visitor.vue